<template>
  <div class="all_part">

    <div class="header">
      <div class="header_left">
        <img src="../assets/mine1.png" alt="">
      </div>
      <!-- 新增站内消息 -->
      <div style="width: 18%;display:flex;justify-content: center;">
      <div class="header_Right" @click="xiaoxiFn">
        <img src="../assets/xiaoxi.png" alt="">
        <div class="header_RightIcon" v-if="messageCount>0">{{messageCount}}</div>
      </div>
      </div>
    </div>
    <div class="header_img">
      <img src="../assets/headerLogo.png" alt="">
    </div>
    <div class="main_button">

      <div class="JiaGeKuCun">

        <div
            class="button"
            @click="PushJiaGe"
            v-if="user_leave.standardType == 1"
        >
          <img src="../assets/home1.png" alt=""/>
          <span>价格与库存</span>
        </div>
        <div
            class="button"
            @click="PushCaiWu"
            v-if="user_leave.financeType == 1"
        >
          <img src="../assets/home2.png" alt=""/>
          <span>应收款与发票</span>
        </div>
        <div
            class="button"
            @click="PushRenWu"
            v-if="user_leave.task == 1"
        >
          <img src="../assets/home3.png" alt=""/>
          <span>内部协调</span>
        </div>
        <div
            class="button"
            @click="PushChanPin"
            v-if="user_leave.master_gear == 1"
        >
          <img src="../assets/home4.png" alt=""/>
          <span>IC产品信息</span>
        </div>
        <div
            class="button"
            @click="ShiChangXinXi"
            v-if="user_leave.competitive_products == 1"
        >
          <img src="../assets/home5.png" alt=""/>
          <span> IC市场情报</span>
        </div>
          <div
            class="button"
            @click="orderFn"
            v-if="user_leave.orderType == 1"
        >
          <img src="../assets/newOrderPc.png" alt=""/>
          <span> 订单中心</span>
        </div>

        <img class="homeback" src="../assets/homeBackground.png" alt="">


        <!--        <div class="button">-->
        <!--          <img src="../assets/Main_menu_img/YingShouKuanYuFaPiao.png" alt="" />-->
        <!--          <span>财务信息</span>-->
        <!--        </div>-->

        <!-- 客服按钮 
        <div class="button" @click="openChat()">
          <img src="../assets/kf1.png" alt="" />
          <span>协调工作任务管理</span>
        </div>
-->

      </div>
    </div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";
export default {
  name: "Main_menuComputer",
  data() {
    return {
      user_leave: {},
      messageCount: 0
    };
  },
  mounted() {
    this.getMessageCount()
    this.getUser();
  },

  methods: {
    //获取未读消息条目数
    getMessageCount() {
      let user = JSON.parse(sessionStorage.getItem('user'));
       this.axios
        .get(
          httpUrl +
            `/api/index/unreadNum?user_id=${user.id}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.messageCount = response.data.data.count;
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    xiaoxiFn() {
      this.$router.push("/NewsPc");
    },
    goIndex(url){
      window.location.href = 'http://www.issealing.com/index.html' + url;
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
    },
    dengji() {
      console.log(1)
      this.$router.push("/second_menuComputer_JingPin");
    },
    PushJiaGe() {
      console.log(2)
      this.$router.push("/second_menuComputer_PriceAndInventory");
    },
    PushChanPin() {
      console.log(3)
      this.$router.push("/ICChanPinXinXi");
    },
    ShiChangXinXi() {
      console.log(4)
      this.$router.push("/CompetitionRegistration");
    },
    orderFn() {
      this.$router.push("/OrderPc");
    },
    PushRenWu() {
      console.log(5)
      this.$router.push("/missionComputer");
    },
    PushCaiWu() {
      console.log(6)
      this.$router.push("/FinanceComputer");
    },

    openChat() {
      var visiter_id = ''
      var visiter_name = ''
      var avatar = ''
      //let data = this.$u.user.getUser()
      //if (data) {
      //  visiter_id = data.user.user_code
      //  visiter_name = data.user.mobile ? data.user.mobile : ''
      //  avatar = data.user.head_pic ? data.user.head_pic : ''
      //}
      const web = encodeURI(
          'https://kf.gmors-shop.cn/index/index/home?theme=FFFFFF&visiter_id=' +
          visiter_id +
          '&visiter_name=' +
          visiter_name +
          '&avatar=' +
          avatar +
          '&business_id=1&groupid=0'
      )
      window.open(web, '_blank')
    },

  },
};
</script>

<style>
</style>
<style scoped>
.homeback {
  z-index: -1;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 65%;
}

.bottomsDiv {
  width: 100%;
}

.bottomsDiv_top {
  height: 12px;
  background-color: #358FE5;
}

.bottomsDiv_div {
  width: 100%;
  height: 227px;
  background: #004b43;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.bottomsDiv_div_div {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  font-size: 14px;
  line-height: 24px;
  color: #94c2a2;
  text-align: center;
}

.bottomsDiv_div img {
  width: 140px;
  margin-bottom: 20px;
}

.content_header {
  margin-top: -10px;
  height: 50px;
  width: 100%;
  background-color: #F2F2F2;
  padding: 0 240px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #666666;
}

.header_img {
  width: 100%;
}

.header_img img {
  width: 100%;
  height: 300px;
}
.header {
  background-color: #FFFFFF;
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header_left {
  width: 26%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.header_left img {
  width: 180px;
}

.header_Right {
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 27px;
}

.header_RightIcon {
    position: absolute;
    top: -9px;
    right: -7px;
    width: 20px;
    height: 20px;
    background: #FF1414;
    border-radius: 50%;
    opacity: 1;
    color: #fff;
    line-height: 20px;
    transform: scale(0.8);
}

.header_Right img {
  width: 20px;
  height: 20px;
}

.header_right_index {
  width: 122px;
  height: 43px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #18a575;
  border-radius: 21.5px;
  font-size: 22px;
  line-height: 22px;
  color: #ffffff;
  margin-right: 30px;
}

.header_right_indexs {
  font-size: 22px;
  line-height: 22px;
  color: #666666;
  margin-right: 24px;
  border: none;
  text-decoration: none;
}


.all_part {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  position: relative;
  justify-content: center;
  display: flex;
  width: 100%;
  overflow: hidden;
  flex: 1;
  padding-top: 150px;
  box-sizing: border-box;
  //height: 70%;
}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.button {
  flex-direction: column;
  display: flex;
  align-items: center;
}

.button img {
  width: 110px;
}

.button span {
  font-weight: 600;
  color: #18a575;
  font-size: 20px;
  margin-top: 10px;
}

.Copyright_information {
  margin-bottom: 15px;
}
</style>
